import {ClassificatorValueModel} from './classificator-value.model';
import {IdCodeNameModel} from 'common-shared';
import {Type} from "class-transformer";

export class ClassificatorModel extends IdCodeNameModel {
  ParentId?: any;
  IsParent: boolean;
  IsSystem: boolean;
  Comment?: any;
  @Type(() => ClassificatorValueModel)
  Values: ClassificatorValueModel[] = [];
  TypeClv: string;

  constructor(init?: Partial<ClassificatorModel>) {
    super();
    Object.assign(this, init);
  }
}
